import { createStore } from 'vuex'
import customReport from './module/customReport'
import helpCenter from './module/helpCenter'
import globalData from './module/globalData'
export default createStore({
  state: {
    // 网站维护通知是否存在未读
    siteNoticeIsRead: false,
    // 统一登录所需的token
    ct_unifyuser_token: '',
    // 站点信息
    stationInfo: {
      // 站点名称
      station_name: '',
      // 站点logo
      plug_corner_icon: '',
    },
    // 用户信息
    userInfo: '',
    // 渠道账户一体化的用户信息
    integrationUserInfo: '',
    // 模块列表（父级为模块权限，子级为报告权限）
    children: [
      {
        key: 11,
        // 报告名称
        name: '融资服务报告',
        // 标记
        sign: 'channel:finance_service_analysis',
        // 标记别名
        signAlias: 'finance_service_analysis',
        // 报告前缀
        prefix: 'fsas',
        // 版本信息
        version: 'FINANCE_SERVICE_ANALYSIS',
      },
      {
        key: 12,
        name: '工商司法匹配报告',
        sign: 'channel:business_justice_analysis',
        signAlias: 'business_justice_analysis',
        prefix: 'bja',
        version: 'BUSINESS_JUSTICE_ANALYSIS',
      },
    ],
    // 拥有权限的路由（功能权限）
    fpRoutes: [],
    // 有权限的默认页面（功能权限）
    fpDefaultPath: '',
    // 特殊渠道ID-需要隐藏流程监控页码的报告查询数量图表（4885：正式渠道，5671：测试渠道）
    hideProcessWatchChartChannelIds: {
      prod: 4855,
      test: 5671,
    },
  },
  getters: {
    // 合作商，是否展示分佣记录
    getDivideCommissionFlag(state) {
      return state.stationInfo.divide_commission_flag
    },
    // 账户类型，(1, '企业') (2, '个人')
    getAccountType(state) {
      return state.userInfo?.account_type
    },
    // 渠道类型 1, '渠道' 2, '合作商'
    getChannelType(state) {
      return state.userInfo?.channel_type
    },
    // 合作模式，【 1-直营，2-渠道贴牌分发， 3-渠道不贴牌分发 】
    getCooperationMode(state) {
      return state.userInfo?.cooperation_mode
    },
    // 【 报告权限配置 】是否沿用渠道配置 1 沿用 -1 不沿用
    getReportFollowSwitch(state) {
      return state.stationInfo?.report_follow_switch
    },
    // 站点全名
    stationFullName(state) {
      return state.stationInfo.station_name + '-管理后台'
    },
    // 站点名称
    stationName(state) {
      return state.stationInfo.station_name
    },
    // 千企千面-报告水印
    reportWatermark(state) {
      customReport.mutations.setGlobalConfig(customReport.state, { value: state.stationInfo.watermark, type: 'reportWatermark' })
      return state.stationInfo.watermark
    },
    // 千企千面-报告图片水印
    reportWatermarkImageUrl(state) {
      customReport.state.globalConfig.reportWatermarkImage = state.stationInfo.report_logo
      return state.stationInfo.report_logo
    },
    // 站点信息
    stationInfo(state) {
      return state.stationInfo
    },
    // 获取，站点信息，上面的那个不够语义化
    getStationInfo(state) {
      return state.stationInfo
    },
    // 获取千企千面，定制版本
    getQQQMVersion(state) {
      const qdStationInfo = JSON.parse(localStorage.getItem('qdStationInfo'))
      var versionArr = state.stationInfo?.qianqiqianmian_custom_version
      if (qdStationInfo) {
        versionArr = qdStationInfo?.qianqiqianmian_custom_version
      }
      if (versionArr?.length > 0) {
        return versionArr[0].template_version
      } else {
        return '通用版本千企千面'
      }
    },
    // 当前渠道id
    channelId(state) {
      return state.userInfo?.channelid
    },
    // 个人账户渠道状态，注意，这是个人账户的
    // 1 启用 -1 禁用 0 非个人
    personalChannelState(state) {
      return state.userInfo?.personal_channel_state
    },
    // 用户类型
    userType(state) {
      // 1:渠道，2:管理员，3:员工，4:后台员工 5:经纪人
      return state.userInfo?.type || ''
    },
    // 是否查看报告支付
    isCheckPay(state) {
      return state.stationInfo.payment_type == 2
    },
    // 当前站点报告权限
    reportPermissions(state) {
      return state.userInfo?.enterprise_analysis_config || []
    },
    getChildrenReportPermissions(state) {
      const analysisList = state.stationInfo?.enterprise_analysis_config || []
      return analysisList.filter((item) => item.parent_id != 0)
    },
    // 历史报告权限记录
    historyPermissions(state) {
      return state.userInfo?.history_authorize_record || []
    },
    // 当前站点拥有的报告权限（树形结构）
    reportPermissionsTree(_, getters) {
      const permissionsTree = []
      if (getters.reportPermissions && getters.reportPermissions.length > 0) {
        const copyPermissions = JSON.parse(JSON.stringify(getters.reportPermissions))
        // 将父级加入权限树中
        permissionsTree.push(...copyPermissions.filter((item) => item.parent_id == 0))
        // 将子级权限插入树中
        copyPermissions
          .filter((item) => item.parent_id != 0)
          .forEach((item) => {
            const parentId = item.parent_id
            if (parentId) {
              // 存在父级id，则认为是子级权限，需要插入树中
              const parentPermission = permissionsTree.find((tItem) => tItem.id == parentId)
              if (parentPermission) {
                // 存在父级权限，进行插入
                if (!Array.isArray(parentPermission.children)) {
                  // 不存在容器，创建容器
                  parentPermission.children = []
                }
                // 插入
                parentPermission.children.push(item)
              }
            }
          })
      }
      // console.log('reportPermissionsTree: ', permissionsTree);
      return permissionsTree
    },
    // 当前和历史所拥有的报告权限
    allReportPermissions(_, getters) {
      const permissionsList = []
      const allPermissions = [].concat(getters.reportPermissions, getters.historyPermissions)
      if (allPermissions && allPermissions.length > 0) {
        // 融资服务权限（比较特殊，只有父级权限，没有子级权限，所以直接找父级权限）
        const financeServicePermission = allPermissions.find((item) => item.parent_id == 0 && item.sign == 'channel:finance_service')
        if (financeServicePermission) {
          permissionsList.push(financeServicePermission)
        }

        // 所有报告权限列表（map去重）
        const permissionsMap = new Map(allPermissions.filter((item) => item.parent_id != 0).map((item) => [item.id, item]))
        permissionsList.push(...permissionsMap.values())
      }
      // console.log('allReportPermissions', permissionsList);
      return permissionsList
    },
    // 员工端地址
    staffProjectSites(state) {
      return state.userInfo?.staff_url || ''
    },
    // 企业端地址
    enterpriseProjectSites(state) {
      return state.userInfo?.enterprise_url || ''
    },
    // 报告管理页面拥有的所有模块权限
    reportModulesPermissions(_, getters) {
      let modulesSignList = []
      if (getters.reportPermissions && getters.reportPermissions.length > 0) {
        // 模块级别的权限
        const modulesPermissions = getters.reportPermissions.filter((item) => item.parent_id == 0)
        // 加入列表
        modulesSignList.push(...modulesPermissions)
      }
      if (getters.historyPermissions && getters.historyPermissions.length > 0) {
        // 模块级别的权限-历史
        const historyModulesPermissions = getters.historyPermissions.filter((item) => item.parent_id == 0)
        historyModulesPermissions.forEach((item) => {
          // 是否已经存在列表中
          const module = modulesSignList.find((mItem) => mItem.id == item.id)
          if (!module) {
            // 不存在，则加入列表
            modulesSignList.push(item)
          }
        })
      }
      return modulesSignList
    },
    // 流程监控页面拥有的报告信息列表
    watchModulesList(_, getters) {
      let modulesInfoList = []
      if (getters.allReportPermissions && getters.allReportPermissions.length > 0) {
        getters.allReportPermissions.forEach((item) => {
          // 如果为父级级别不需要
          if (item.parent_id === 0) return
          modulesInfoList.push({
            name: item.name,
            sign: item.sign,
            // 取出报告别名，实际上这个标记比较常用
            signAlias: item.sign.replace('channel:', ''),
            // 如果没有排序值，则设置为默认99
            sort_num: item.sort_num || 99,
          })
        })
      }
      modulesInfoList.sort((a, b) => {
        return a.sort_num - b.sort_num
      })
      return modulesInfoList
    },
    // 当前渠道是否存在合作商
    existPartner(state) {
      return state.userInfo?.admin_exists || false
    },
    // 当前用户的功能权限
    functionalPermissions(state) {
      return state.userInfo.functional_permission || []
      // return state.userInfo.functional_permission || JSON.parse(localStorage.getItem('wp_userInfo')).functional_permission || []
    },
    // 是否存在创建合作商角色的权限（渠道专有）
    createPartnerRolePermission(_, getters) {
      const exist = getters.functionalPermissions.find((item) => item.code === 'pms:partner_role')
      return exist ? true : false
    },
    // 是否存在报告下载权限
    reportDownloadPermission(_, getters) {
      const exist = getters.functionalPermissions.find((item) => item.code === 'pms:report_download')
      return exist ? true : false
    },
    // 是否存在尽调白名单匹配权限
    jcaReportWhiteListPermission(_, getters) {
      const exist = getters.functionalPermissions.find((item) => item.code === 'pms:jindiao_white_list')
      return exist ? true : false
    },
    // 检测某个功能权限是否拥有
    checkFunctionalPermission(_, getters) {
      return (permissionCode) => {
        const exist = getters.functionalPermissions.find((item) => item.code === permissionCode)
        return exist ? true : false
      }
    },
    // 是否存在生成邀请码的权限
    generateInvitationCode(_, getters) {
      const exist = getters.functionalPermissions.find((item) => item.code === 'pms:invite_code')
      return !!exist
    },
    // 是否存在财务充值权限
    financialRechargePermission(_, getters) {
      const exist = getters.functionalPermissions.find((item) => item.code === 'pms:financial_recharge')
      return exist ? true : false
    },
  },
  mutations: {
    // 设置统一登录接口所需的token
    setUserIdentifyToken(state, info) {
      localStorage.setItem('we_ct-unifyuser-token', info['ct-unifyuser-token'])
      state.ct_unifyuser_token = info['ct-unifyuser-token']
    },
    // 设置站点信息
    setStationInfo(state, info) {
      state.stationInfo = info
    },
    // 设置用户信息
    setUserInfo(state, info) {
      state.userInfo = info
    },
    // 设置渠道账户一体化的用户信息
    setIntegrationUserInfo(state, info) {
      state.integrationUserInfo = info
    },
    // 设置通知信息是不是全部已读
    setSiteNoticeStatus(state, status) {
      // console.log('siteNoticeIsReadState', status)
      state.siteNoticeIsRead = status
    },
    // 设置有权限的路由列表（功能权限）
    setFpRoutes(state, routes) {
      state.fpRoutes = routes
    },
    // 设置有权限的一个页面为默认页面（功能权限）
    setFpDefaultPath(state, path) {
      state.fpDefaultPath = path
    },
  },
  actions: {},
  modules: {
    customReport,
    helpCenter,
    globalData
  },
})
